import ServiceCRUD from '../../../../services/ServiceCRUDFLEXUC';

class UserService extends ServiceCRUD {
  constructor() {
    super('/api/usuarios');
  }
}

export default new UserService();
